import React, { useEffect } from 'react';
import styled from 'styled-components';
import { compose } from 'redux';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { useMsal } from '@azure/msal-react';
import { useNavigate } from 'react-router-dom';
import appsettings from 'nallian-shared-ui/lib/config/appsettings';
import { Segment } from 'nallian-shared-ui/lib/components';
import communityService from 'nallian-shared-ui/lib/services/communityService';
import { loginRequest } from 'nallian-shared-ui/lib/authentication/constants/config';
import LanguageSelector from 'nallian-shared-ui/lib/layout/LanguageSelector';
import BasicLayout from '../../app/components/BasicLayout';
import GuestActions from './GuestActions';
import CommunityText from './CommunityText';
import AwaitApplicationLoaded from '../hoc/AwaitApplicationLoaded';
import { WELCOME_TEXT_TYPE_ID } from '../../../mgmt/communities/components/legalAndTexts/constants';

const StyledSegment = styled(Segment)`
  max-width: 50rem;
  min-height: 15rem;
  &.ui.segment {
    margin: 0 auto;
  }
`;

const LandingPage = ({ myCommunityFetch }) => {
  // below is the only way possible since we're not in our provider of msal yet.
  const { instance } = useMsal();
  const { i18n } = useTranslation();
  const navigate = useNavigate();

  const { language } = i18n;

  useEffect(() => {
    const check = async () => {
      try {
        await instance.ssoSilent({
          ...loginRequest,
          authority: appsettings.authority,
        });

        navigate(`/overview`);
        return true;
      } catch (error) {
        // Do nothing because we want to stay on the page since we're not logged in
        return false;
      }
    };

    check();
  }, [instance, navigate]);

  return (
    <BasicLayout>
      <LanguageSelector isPublic />
      <StyledSegment>
        {myCommunityFetch.value?.defaultLanguageId && (
          <CommunityText
            myCommunityFetch={myCommunityFetch}
            language={language || myCommunityFetch.value?.defaultLanguageId || 'en'}
            communityTag={myCommunityFetch.value?.tag}
            type={WELCOME_TEXT_TYPE_ID}
          />
        )}
        <br />
        <GuestActions />
      </StyledSegment>
    </BasicLayout>
  );
};

LandingPage.propTypes = { myCommunityFetch: PropTypes.object.isRequired };

export default compose(AwaitApplicationLoaded, communityService)(LandingPage);
